import styled from "styled-components";

export const BusinessHeaderWrapper = styled.div`
    padding-top: 33px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 20px;

    @media (min-width: 992px) {
        flex-direction: row;
        gap: 0;
    }
    .heading-wrap {
        flex-grow: 1;
        .heading {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            @media (min-width: 576px) {
                font-size: 32px;
                line-height: 36px;
            }
            @media (min-width: 768px) {
                font-size: 36px;
                line-height: 40px;
            }
        }
    }

    .filters {
        display: flex;
        gap: 16px;

        @media (max-width: 576px) {
            flex-wrap: wrap;
        }

        button {
            font-size: 15px;
            font-weight: 400;
            line-height: 19px;

            @media (max-width: 576px) {
                max-width: 100%;
                height: 50px;
            }
        }
        .Search {
            > div:first-of-type {
                margin-bottom: 0;
            }
            input {
                height: 50px;
                padding-left: 2.8rem;
            }
            @media (max-width: 576px) {
                width: 100%;
            }
            .icon {
                display: flex;
                justify-content: center;
                width: 25px;
                height: 25px;
                border-radius: 26px;
                border: 0.8px solid rgba(157, 157, 157, 0.2);
                align-items: center;
                font-size: 20px;
                padding: 3px;
            }
        }
        .filter-options {
            width: 120px;
            > div:first-of-type {
                margin-bottom: 0;
            }
            .react-select__control {
                height: 50px;
            }
            @media (max-width: 576px) {
                width: 100%;
            }
        }
    }
`;
